import script from "./TarjetaProximaReservaAcciones.vue?vue&type=script&setup=true&lang=js"
export * from "./TarjetaProximaReservaAcciones.vue?vue&type=script&setup=true&lang=js"

import "./TarjetaProximaReservaAcciones.vue?vue&type=style&index=0&id=97d55a7a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97d55a7a"]])

export default __exports__